import { BaseVue } from "@newview/base-web";
import { runActions } from "../action";
import { NmisApi } from "../api/nmisApi";
import { ApiOption, IDecorator, INmis } from "../types";
import filterTool from "../util/filterTool";
import { fromJS } from "immutable";

export class Decorator implements IDecorator {

    nmis?: INmis;

    valueObj: any = undefined;

    //#region 方法    

    /**
     * 解析 props style class
     */
    autoFilterPropsStyleClass() {

        if (!filterTool.isNull(this.nmis!.copySchemaNode!["props"])) {
            filterTool.autoFilterObject(this.nmis!.copySchemaNode!["props"], this.nmis!.schemaNode["props"], this.nmis!.openData);
        }

        if (!filterTool.isNull(this.nmis!.copySchemaNode!["style"])) {
            filterTool.autoFilterObject(this.nmis!.copySchemaNode["style"], this.nmis!.schemaNode["style"], this.nmis!.openData);
        }

        if (!filterTool.isNull(this.nmis!.copySchemaNode["class"])) {
            this.nmis!.copySchemaNode["class"] = filterTool.autoFilterValue(this.nmis!.schemaNode["class"], this.nmis!.openData);
        }
    }

    /**
     * 转化为BaseVue类型
     * @returns 
     */
    baseVue() {
        return this.nmis! as unknown as BaseVue
    }

    /**
     * 添加Prop
     * @param key 
     * @param value 
     */
    addProp(key, value) {
        this.nmis!.copySchemaNode["props"][key] = value;
    }

    /**
     * 添加事件监听
     */
    addEvent(key, value) {
        this.nmis!.copySchemaNode["on"][key] = value;
    }

    /**
     * 设置数据源数据
     * @param data 
     */
    setSource(data) {
        this.nmis!.currentData = Object.assign(this.nmis!.currentData, {
            source: data
        });

        this.nmis!.openData = filterTool.openData(this.nmis!.currentData);
    }

    isParseEvent() {
        return true;
    }

    /**
     * 解析事件
     * @param callback 
     */
    parseEvent() {
        if (!this.isParseEvent()) {
            return;
        }
        const orgOn = this.nmis!.schemaNode.on;
        for (const key in orgOn) {
            if (key == 'input') {
                continue;
            }

            const eventSchema = orgOn[key];

            if (typeof eventSchema === 'function') {
                continue;
            }

            this.addEvent(key, (data) => {
                let newData = filterTool.isNull(data) ? this.nmis!.openData : typeof data == 'object' ? Object.assign(data, this.nmis!.openData) : data;
                runActions(eventSchema.actions, newData, this.nmis!.componentIdMap, this.nmis);
            });
        }
    }

    /**
     * 获取事件actions
     * @param eventName 
     * @returns 
     */
    getEventActions(eventName) {
        if (filterTool.isNull(this.nmis!.schemaNode.on)) {
            return undefined;
        }

        if (filterTool.isNull(this.nmis!.schemaNode.on[eventName])) {
            return undefined;
        }
        return this.nmis!.schemaNode.on[eventName].actions;
    }

    /**
     * filter Source中的数据
     * @param event 
     * @returns 
     */
    filterSourceData(event?: any) {
        if(Array.isArray(event)) {
            return event;
        }
        const source: ApiOption = this.nmis!.copySchemaNode.source;
        const orgSource: ApiOption = this.nmis!.schemaNode.source;
        let newData = source.data;

        // if (filterTool.isNull(event)) {
        //     return newData;
        // }

        if (orgSource.isFilter != false && !filterTool.isNull(newData)) {
            let openData = this.nmis!.openData;
            if (!filterTool.isNull(event) && !filterTool.isNull(event.data)) {
                openData = Object.assign(filterTool.jsonClone(event), openData)
            }

            filterTool.autoFilterObject(newData, orgSource.data, openData);
        }

        return newData;
    }

    /**
     * 初始化值对象, 无则向上级查找
     * @param data 
     * @param name 
     * @returns 
     */
    initValueObj(data, name) {
        if (Object.prototype.hasOwnProperty.call(data, name)) {
            this.valueObj = data;
            return data[name];
        }

        const parentData = data.__super;
        if (!filterTool.isNull(parentData)) {
            if (Object.prototype.hasOwnProperty.call(parentData, 'globalData')) {
                this.valueObj = parentData;
                this.nmis!.$set(this.valueObj, name, undefined);
                return undefined;
            }
            return this.initValueObj(data.__super, name);
        } else {
            this.valueObj = data;
            this.nmis!.$set(this.valueObj, name, undefined);
        }
    }

    //#endregion 方法

    //#region 生命周期

    /**
     * created
     * @param nmis 
     */
    created(nmis: INmis) {
        this.nmis = nmis;
    }

    /**
     * 初始化
     * @param nmis 
     */
    start(nmis: INmis) {
        this.nmis = nmis;

        if (filterTool.isNull(this.nmis!.copySchemaNode["props"])) {
            this.nmis!.copySchemaNode["props"] = {};
        }

        if (filterTool.isNull(this.nmis!.copySchemaNode["on"])) {
            this.nmis!.copySchemaNode["on"] = {};
        }

        const name: string = filterTool.isNull(this.nmis!.copySchemaNode["name"]) ? '' : this.nmis!.copySchemaNode["name"];

        // 设置 props
        if (!filterTool.isNull(name)) {
            this.initValueObj(this.nmis!.currentData, name);
            this.addProp("value", this.valueObj[name]);
        }

        // 解析事件
        this.parseEvent();

        // 设置 input 事件
        this.addEvent("input", (event) => {
            if (filterTool.isNull(name)) {
                return;
            }
            this.nmis!.$set(this.valueObj, name, event);
            // this.nmis!.$emit('change', name, event);
        });

        // 填充值
        this.autoFilterPropsStyleClass();
    }

    /**
     * 获取当前对象新实例
     * @returns 
     */
    getInstance() {
        return new Decorator();
    }

    /**
     * 开始初始化，可以通过修改schema，进行事件拦截
     */
    beforeInit() { }

    /**
     * 初始化完成，dom已创建
     */
    inited() { }

    //#endregion 生命周期


    // ======================================================================================
    // ==================================  公开Api定义区 =====================================
    // ======================================================================================
    /**
     * 对象深复制
     * @param obj 
     * @returns 
     */
    fromJS(obj) {
        return fromJS(obj).toJS();
    }

    /**
     * 设置值
     * @param value 
     * @param event 
     */
    setValue(value: any, event?: any) {
        let data = value;
        if (typeof (value) == 'string') {
            data = filterTool.autoFilterValue(value, event)
        } else {
            data = filterTool.jsonClone(value);
            filterTool.autoFilterObject(data, value, event)
        }
        this.nmis!.currentData = Object.assign(this.nmis!.currentData, data);
        this.nmis!.openData = filterTool.openData(this.nmis!.currentData);
        // this.nmis!.changeIndex! += 1;
        this.nmis!.update();
    }

    /**
     * 显隐控制
     * @param type 
     */
    showHidden(type: 'show' | 'hidden' | "mutex") {
        if (type == 'mutex') {
            this.nmis!.schemaNode.show = filterTool.isNull(this.nmis!.schemaNode.show) ? true : !this.nmis!.schemaNode.show;
            return;
        }
        this.nmis!.schemaNode.show = type == 'show';
        this.nmis!.update();
    }

    /**
     * 启用禁用
     * @param type 
     */
    enableOrDisable(type: "enabled" | "disabled") {
        this.nmis!.schemaNode.disabled = type == 'disabled';
        this.nmis!.update();
    }

    /**
     * 设置全局值
     * @param key 
     * @param value 
     * @param event 
     * @param isOnlyAddSetValue 
     */
    setGloablValue(key: string, value: string, isOnlyAddSetValue?: boolean, event?: any) {

    }

    /**
     * 加载数据
     */
    async loadData(event?: any) {
        // 过滤数据
        let newData = this.filterSourceData(event);

        // 发送请求
        const apiResult = await NmisApi.send(this.nmis!.copySchemaNode.source, newData, this.nmis!.projectId, this.nmis!.childsysId, this.nmis!.devProd);
        if (apiResult == undefined) {
            return;
        }

        const data = this.baseVue().parseApiResult(apiResult);
        this.setSource(data);
    }

    getProjectId() {
        return this.nmis!.projectId;
    }
    getChildsysId() {
        return this.nmis!.childsysId;
    }
    getDevProd() {
        return this.nmis!.devProd;
    }
    /**
     * 弹出提示框
     * @param content 
     * @param okCallback 
     * @param cancelCallback 
     * @param okText 
     * @param cancelText 
     * @param title 
     */
    confirm(content, okCallback, cancelCallback?: any, okText?: string, cancelText?: string, title?: string) {
        return this.nmis!.confirm(content, okCallback, cancelCallback, okText, cancelText, title);
    }
    /**
     * 更新
     */
    update() {
        return this.nmis!.update();
    }
    /**
     * 获取根组件
     */
    getRootComponent() {
        return this.nmis!.getRootComponent();
    }
    /**
     * 根据Id获取组件
     * @param componentId 
     */
    getComponentById(componentId: string) {
        return this.nmis!.getComponentById(componentId);
    }
    /**
     * 根据组件Id获取数据
     * @param componentId 
     */
    getDataById(componentId: string) {
        return this.nmis!.getDataById(componentId);
    }
    /**
     * 根据组件Id设置数据
     * @param componentId 
     * @param data 
     */
    setDataById(componentId: string, data: any) {
        return this.nmis!.setDataById(componentId, data);
    }
    /**
     * 设置数据
     * @param data 
     */
    setData(data: any) {
        return this.nmis!.setData(data);
    }
    /**
     * 获取数据
     */
    getData() {
        return this.nmis!.getData();
    }
    /**
     * 弹出成功消息
     * @param content 
     */
    success(content: string): void {
        return this.nmis!.success(content);
    }
    /**
     * 弹出警告消息
     * @param content 
     */
    warning(content: string): void {
        return this.nmis!.warning(content);
    }
    /**
     * 弹出异常消息
     * @param content 
     */
    error(content: string): void {
        return this.nmis!.error(content);
    }

    /**
     * 判断对象是否为Null
     * @param obj 
     * @returns 
     */
    isNull(obj) {
        return this.nmis!.isNull(obj);
    }

    // ======================================================================================
    // ==================================  公开Api定义区END ==================================
    // ======================================================================================
}
